import http from "@/plugins/axios";

const post = (url, data = {}, config = {}) => http.post(url, data, config);
const get = (url, config = {}) => http.get(url, config);

export default {
  getHomeHeader: () => get("v1/home/header"),
  getHomeStories: () => get("v1/home/stories"),
  getHomeFeed: () => get("v1/home/feed"),
  getHomeJobs: () => get("v1/home/jobs"),
  getHomeEvents: () => get("v1/home/events"),
  getHomeBusinesses: () => get("v1/home/businesses"),
  getHomeOffers: () => get("v1/home/offers"),
  getHomeSponsored: () => get("v1/home/sponsored"),
  getHome: () => post("getfrontview"),
  getEditData: (name, id) => post("getfrontedit", { _name: name, _id: id }),
  getCanvas: () => post("getcanvasview"),
  getSidebar: () => post("getsidebarview"),
  getListingDetails: (id, name) =>
    post("singleeventlist", { _id: id, _name: name }),
  getListingsByType: (name, title) =>
    post("getview", { _name: name, _title: title }),
  getBusinessesByCategory: (categoryId) =>
    post("filterbusinesscat", { _cat_id: categoryId }),
  getFoodByCategory: (categoryId) =>
    post("filterfoodcat", { _cat_id: categoryId }),
  getEventsByCategory: (categoryId) =>
    post("filtereventcat", { _cat_id: categoryId }),
  requestOtp: (data) =>
    post("newregister", data, {
      globalLoading: true,
      loadingMessage: "Sending OTP...",
    }),
  verifyOtp: (data) =>
    post("verifyregistration", data, {
      globalLoading: true,
      loadingMessage: "Verifying OTP...",
    }),
  saveFood: (data, config = {}) =>
    post("savefood", data, {
      ...config,
      globalLoading: true,
      loadingMessage: "Submitting...",
    }),
  saveEvent: (data, config = {}) =>
    post("saveevent", data, {
      ...config,
      globalLoading: true,
      loadingMessage: "Submitting...",
    }),
  saveNews: (data, config = {}) =>
    post("savenews", data, {
      ...config,
      globalLoading: true,
      loadingMessage: "Submitting...",
    }),
  saveBusiness: (data, config = {}) =>
    post("savebusiness", data, {
      ...config,
      globalLoading: true,
      loadingMessage: "Submitting...",
    }),
  saveProperty: (data, config = {}) =>
    post("saveproperty", data, {
      ...config,
      globalLoading: true,
      loadingMessage: "Submitting...",
    }),
  saveJob: (data, config = {}) =>
    post("savejob", data, {
      ...config,
      globalLoading: true,
      loadingMessage: "Submitting...",
    }),
  getProfile: () => post("getprofileview"),
  updateProfile: (name) => post("update_profile", { name }),
  completeProfile: (data) =>
    post("complete_profile", data, {
      globalLoading: true,
      loadingMessage: "Saving profile...",
    }),
  toggleSaved: (id, type) =>
    post(
      "toggle_saved",
      { id, type },
      { globalLoading: true, loadingMessage: "Saving..." },
    ),
  getProfileFeatures: () => get("profile_features"),
  markNotificationRead: (id) => post("notification_read", { id }),
  toggleListing: (id, type) => post("disable_list", { _id: id, _what: type }),
  search: (searchText) => post("getfilterlist", { _string: searchText }),
  getCategories: () => post("getCategories"),
  getEvents: () => post("getEvents"),
  getNews: () => post("getNews"),
  getJobs: () => post("getJobs"),
  getFood: () => post("getFood"),
  getBusinessListings: () => post("getListings"),
  getProperties: () => post("getProperties"),
  getTemperature: () => post("getTemperature"),
  getUserProfile: () => post("getUserProfile"),
  getDailyNeeds: () => post("getDailyNeeds"),
  getEmergencies: () => post("getEmergencies"),
};
